import "./polyfill/promiseWithResolvers";
import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import App from "./components/App.tsx";
import { theme } from "./theme";
import { initSentry } from "./services/sentry";
import { initPostHog } from "./services/posthog";

if (import.meta.env.REACT_APP_MODE === "production") {
  initSentry();
}
initPostHog();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
